import { render, staticRenderFns } from "./Sitemaps.vue?vue&type=template&id=147c8996&"
import script from "./Sitemaps.vue?vue&type=script&lang=js&"
export * from "./Sitemaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports